import { VARIANTS } from '../../../designSystem';
const FOOTER_BUTTON_GHOST_PROPS = {
    size: VARIANTS.ButtonSizeType.ICON_SMALL,
};
export { FOOTER_BUTTON_GHOST_PROPS };
//# sourceMappingURL=footer.constants.js.map